"use client";
import { useState } from "react";

// Libraries
import Image from "next/image";

// Hooks
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import { getCdnImagePath } from "@/utils/bus/getCdnImagePath";

// Components
import SeachFormsCampaignListener from "@/components/SeachFormsCampaignListener";
import BottomSheet from "@/components/ui/BottomSheet";

const LayoutWrapper = ({
  children,
  pnrFormComponent: PnrFormComponent,
  checkInFormComponent: CheckInFormComponent,
  translationNamespace = "common",
}) => {
  const t = useTranslationDetector();
  const [isPnrModalOpen, setIsPnrModalOpen] = useState(false);
  const [isCheckInModalOpen, setIsCheckInModalOpen] = useState(false);

  const handlePnrClick = () => {
    setIsPnrModalOpen(true);
  };

  const handleCheckInClick = () => {
    setIsCheckInModalOpen(true);
  };

  const closePnrModal = () => {
    setIsPnrModalOpen(false);
  };

  const closeCheckInModal = () => {
    setIsCheckInModalOpen(false);
  };

  // BottomSheet handles mobile gating, animations and body scroll lock internally

  return (
    <div className="flex flex-col gap-4 md:gap-6">
      {/* Ana form */}
      {children}

      <SeachFormsCampaignListener wrapperClassName="order-1 sm:order-2" />

      {/* Mobile PNR & Check-In Butonları */}
      <div className="shadow-small order-2 flex items-center justify-center rounded-lg bg-white/90 sm:order-1 md:hidden">
        <button
          onClick={handlePnrClick}
          className="inline-flex w-1/2 items-center justify-center gap-4 p-6"
        >
          <Image
            src={getCdnImagePath("/saka/common/svg/monitor.svg")}
            alt={t(`${translationNamespace}.pnrSearch`)}
            width={36}
            height={32}
          />
          <span className="text-foreground-default text-left text-sm leading-19 font-medium whitespace-pre-line">
            {t(`${translationNamespace}.pnrSearch`)}
          </span>
        </button>
        <span className="bg-primary-weak h-[42px] w-[0.66px]"></span>
        <button
          onClick={handleCheckInClick}
          className="inline-flex w-1/2 items-center justify-center gap-4 p-6"
        >
          <Image
            src={getCdnImagePath("/saka/common/svg/ticket-transactions.svg")}
            alt={t(`${translationNamespace}.checkIn`)}
            width={39}
            height={31}
          />
          <span className="text-foreground-default text-left text-sm leading-19 font-medium whitespace-pre-line">
            {t(`${translationNamespace}.checkIn`)}
          </span>
        </button>
      </div>

      {/* PNR BottomSheet */}
      {PnrFormComponent && (
        <BottomSheet
          isOpen={isPnrModalOpen}
          onClose={closePnrModal}
          title={t(`${translationNamespace}.pnrSearch`)}
          innerClassName="pt-2"
          borderClassName="border-b-0"
          //headerClassName="pl-[30px]"
        >
          <PnrFormComponent onClose={closePnrModal} />
        </BottomSheet>
      )}

      {/* Check-In BottomSheet */}
      {CheckInFormComponent && (
        <BottomSheet
          isOpen={isCheckInModalOpen}
          onClose={closeCheckInModal}
          title={t(`${translationNamespace}.checkIn`)}
          innerClassName="pt-2"
          borderClassName="border-b-0"
          //headerClassName="pl-[30px]"
        >
          <CheckInFormComponent onClose={closeCheckInModal} />
        </BottomSheet>
      )}
    </div>
  );
};

export default LayoutWrapper;
